// eslint-disable-next-line import/prefer-default-export
export const isGerman = (lang: string) => lang === 'de'
